module.exports = __webpack_public_path__ + "img/list3.721d8009.png";